<template>
  <section class="storeListDiv">
    <viewTitle
      title="业务管理 / 基础数据管理 / 仓库及装卸平台管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button type="primary" @click="modifyTpl('', 'add')" size="small">
          新建仓库或装卸平台
        </el-button>
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">归属仓库: </span>
        <el-select
          class="ctl"
          v-model="params.store"
          placeholder="请选择归属仓库"
          @change="changeStore"
          clearable
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="item in storeOption"
            :key="item.id"
          ></el-option>
        </el-select>
        <span class="rectl">状态: </span>
        <el-select
          class="ctl"
          clearable
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <span class="rectl">装卸类型: </span>
        <el-select
          class="ctl"
          clearable
          @clear="params.loadType = 0"
          v-model="params.loadType"
          placeholder="请选择状态"
          @change="changeLoadType"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in loadOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <!-- style="position: absolute;width: 100%"
        :height="isOverSize ? maxSize : 'auto'"
        :class="{ auto: !isOverSize }"
        show-overflow-tooltip
        :data="tableData" -->
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-na
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">仓库</span>
            <span v-if="scope.row.type === 2">装卸平台</span>
          </template>
        </el-table-column>
        <el-table-column label="归属仓库">
          <template slot-scope="scope">
            {{ scope.row.store_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="仓库或装卸平台名称">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="装卸类型">
          <template slot-scope="scope">
            {{
              scope.row.loading_unloading_type === 0
                ? "--"
                : loadTypeOption[scope.row.loading_unloading_type - 1]
            }}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.note || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-if="scope.row.state === 2" class="color67">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item
                    @click.native.stop="modifyTpl(scope.row, 'edit')"
                    >编辑</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'forbid')"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'start')"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <!-- 禁用  删除 -->
    <el-dialog :visible.sync="dialogParams.dialogMoveUpShow" width="30%">
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogMoveUpContent"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.dialogMoveUpShow = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          size="small"
          :class="dialogParams.dialogType === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.dialogType === 'del' ? 'danger' : 'primary'"
          @click="confirmMoveUp"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.showModify"
      width="43%"
      :close-on-click-modal="false"
      :title="
        dialogParams.typeModify === 'add'
          ? '新建仓库或装卸平台'
          : '编辑仓库或装卸平台'
      "
    >
      <div>
        <el-form label-width="120px">
          <el-form-item label="类型" :rules="[{ required: true, message: '' }]">
            <el-select
              v-model="modifyParams.storeType"
              placeholder="请选择类型"
              style="width: 100%;"
              @change="changeModifyStoreType"
              :disabled="dialogParams.typeModify === 'edit'"
            >
              <el-option key="0" label="仓库" value="0"> </el-option>
              <el-option key="1" label="装卸平台" value="1"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="归属仓库"
            :rules="[{ required: true, message: '' }]"
            v-if="String(modifyParams.storeType) === '1'"
          >
            <el-select
              v-model="modifyParams.wareHouse"
              placeholder="请选择归属仓库"
              style="width: 100%;"
            >
              <el-option
                v-for="item in wareHouseOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="
              String(modifyParams.storeType) === '0' ? '仓库名称' : '平台名称'
            "
            :rules="[{ required: true, message: '' }]"
          >
            <el-input
              v-model="modifyParams.name"
              :placeholder="
                modifyParams.storeType === '0'
                  ? '请输入仓库名称'
                  : '请输入平台名称'
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            label="装卸类型"
            :rules="[{ required: true, message: '' }]"
            v-if="String(modifyParams.storeType) === '1'"
          >
            <el-select
              v-model="modifyParams.loadType"
              placeholder="请选择装卸类型"
              style="width: 100%;"
            >
              <el-option
                v-for="(item, index) in loadTypeOption"
                :key="index"
                :label="item"
                :value="index"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="modifyParams.remark"
              placeholder="请输入备注（50字符以内）"
              rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">
          <span>取 消</span>
        </el-button>
        <el-button type="primary" @click="save" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        state: 0, // 状态
        store: "", // 归属仓库
        loadType: 0 // 装卸类型
      },
      dialogParams: {
        show: false,
        title: "确认提醒",
        content: "",
        showModify: false, // 编辑 显示
        typeModify: "", // edit、add
        dialogMoveUpShow: false, // 上移一位弹窗
        dialogType: "", // 弹窗类型
        dialogPassShow: false, // 密码弹窗显示
        dialogResetPassShow: false, // 重置密码确认弹窗显示
        dialogUploadShow: false // 导入文件
      },
      modifyParams: {
        // 添加、编辑参数
        storeType: "0", // 类型 仓/库
        id: 0, // id 0为新建，不为空为编辑
        name: "", // 名称
        remark: "", // 备注
        wareHouse: "", // 归属仓库
        loadType: "" // 装卸类型
      },
      fullscreenLoading: false,
      maxSize: 0,
      wareHouseOption: [], // 归属仓库
      loadTypeOption: ["装货", "卸货", "装卸一体"],
      tableData: [], // 表格数据
      stateOption: ["全部", "正常", "已禁用"],
      loadOption: ["全部", "装货", "卸货", "装卸一体"],
      storeOption: [
        {
          name: "全部",
          id: ""
        }
      ],
      dialogMoveUpContent: "",
      rowDataObj: {}
    };
  },

  mixins: [mixinTableLyout],

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    this.getWareList();
    this.getList();
  },

  async activated() {},

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let requestData = {};
      // store 1.不传递时，获取全部数据; 2.传空时获取所有仓
      if (this.params.store === "") {
        requestData = {
          state: this.params.state,
          keyword: this.params.keyword,
          loading_unloading_type:
            this.params.loadType === 0 ? "" : this.params.loadType,
          page: this.page,
          page_size: this.pageSize
        };
      } else {
        requestData = {
          warehouse_id: this.params.store,
          state: this.params.state,
          keyword: this.params.keyword,
          loading_unloading_type:
            this.params.loadType === 0 ? "" : this.params.loadType,
          page: this.page,
          page_size: this.pageSize
        };
      }
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_warehouse",
        data: requestData
      });
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 获取仓库列表
    async getWareList() {
      this.storeOption = [
        {
          name: "全部",
          id: ""
        }
      ];
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_warehouse",
        data: {
          warehouse_id: "",
          state: "",
          keyword: "",
          page_size: 0
        }
      });
      dataObj.data.data.forEach(item => {
        this.storeOption.push(item);
      });
      this.wareHouseOption = dataObj.data.data;
    },

    // 编辑-修改类型
    changeModifyStoreType() {
      this.modifyParams.name = "";
      this.modifyParams.remark = "";
      this.modifyParams.wareHouse = "";
      this.modifyParams.loadType = "";
    },

    // 修改状态
    changeState(val) {
      this.page = 1;
      this.params.state = val;
      this.getList();
    },

    // 修改归属仓库
    changeStore(val) {
      this.page = 1;
      this.params.store = val;
      this.getList();
    },

    // 修改装卸类型
    changeLoadType(val) {
      this.page = 1;
      this.params.loadType = val;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/appoint/modify",
        query: {
          type: "edit"
        }
      });
    },

    // 编辑
    modifyTpl(row, tag) {
      this.dialogParams.typeModify = tag;
      this.dialogParams.showModify = true;
      this.rowDataObj = row;

      if (tag === "edit") {
        this.modifyParams.id = row.id;
        this.modifyParams.name = row.name;
        this.modifyParams.remark = row.note;
        this.modifyParams.storeType = String(row.type - 1);
        this.modifyParams.wareHouse = row.warehouse_id;
        this.modifyParams.loadType = row.loading_unloading_type - 1;
      }
    },

    // 保存
    save() {
      console.log("保存");
      if (
        this.modifyParams.wareHouse === "" &&
        Number(this.modifyParams.storeType) === 1
      ) {
        this.$common.pcToastFail("请选择归属仓库");
        return false;
      }
      if (this.modifyParams.name.trim() === "") {
        this.$common.pcToastFail("名称不能为空");
        return false;
      }
      if (
        this.modifyParams.loadType === "" &&
        Number(this.modifyParams.storeType) === 1
      ) {
        this.$common.pcToastFail("请选择装卸类型");
        return false;
      }
      if (this.modifyParams.remark.trim().length > 50) {
        this.$common.pcToastFail("备注不能超过50个字");
        return false;
      }
      let data = {
        id: this.modifyParams.id,
        name: this.modifyParams.name,
        note: this.modifyParams.remark,
        warehouse_id: this.modifyParams.wareHouse
      };
      if (this.modifyParams.storeType === "1") {
        data.loading_unloading_type = this.modifyParams.loadType + 1;
      }
      console.log(data);
      this.$common
        .http({
          url: "/api/queue/admin/save_warehouse",
          data: data
        })
        .then(res => {
          this.dialogParams.showModify = false;
          if (res.data.data) {
            if (this.dialogParams.typeModify === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          this.getWareList();
          // 重置表单
          for (let key in this.modifyParams) {
            this.modifyParams[key] = "";
          }
          this.modifyParams.id = 0;
          this.modifyParams.storeType = "0";
        });
    },

    // confirmSave() {
    //   let data = {
    //     id: this.modifyParams.id,
    //     name: this.modifyParams.name,
    //     note: this.modifyParams.remark,
    //     warehouse_id: this.modifyParams.wareHouse
    //   };
    //   if (this.modifyParams.storeType === "1") {
    //     data.loading_unloading_type = this.modifyParams.loadType;
    //   }
    //   console.log(data);
    //   this.$common
    //     .http({
    //       url: "/api/queue/admin/save_unit",
    //       data: data
    //     })
    //     .then(res => {
    //       if (res.data.data) {
    //         if (this.dialogParams.typeModify === "add") {
    //           this.$common.pcToastSuccess("添加成功");
    //         } else {
    //           this.$common.pcToastSuccess("保存成功");
    //         }
    //       }
    //       this.getList();
    //       // 重置表单
    //       for (let key in this.modifyParams) {
    //         this.modifyParams[key] = "";
    //       }
    //       this.modifyParams.id = 0;
    //       this.modifyParams.storeType = "0";
    //     });
    // },

    // 取消
    cancel() {
      this.dialogParams.showModify = false;
      for (let key in this.modifyParams) {
        this.modifyParams[key] = "";
      }
      this.modifyParams.id = 0;
      this.modifyParams.storeType = "0";
    },

    // 禁用/删除
    moveUp(row, tag) {
      this.dialogParams.dialogType = tag;
      this.dialogParams.dialogMoveUpShow = true;
      this.dialogParams.title = "确认提醒";
      this.rowDataObj = row;
      let text = row.type === 1 ? "仓库" : "装卸平台";
      if (tag === "forbid") {
        this.dialogMoveUpContent = `确定要禁用“<span class="color67">${this.rowDataObj.name}</span>”的${text}信息？`;
      } else if (tag === "start") {
        this.dialogMoveUpContent = `确定要启用“<span class="color67">${this.rowDataObj.name}</span>”的${text}信息？`;
      } else if (tag === "del") {
        this.dialogMoveUpContent = `确定要删除“<span class="color67">${this.rowDataObj.name}</span>”的${text}信息？`;
      }
    },

    // 确认操作
    confirmMoveUp() {
      if (this.dialogParams.title === "确认提醒") {
        this.dialogParams.dialogMoveUpShow = false;
        let url = "";
        if (this.dialogParams.dialogType === "del") {
          url = "/api/queue/admin/del_warehouse";
        } else if (
          this.dialogParams.dialogType === "start" ||
          this.dialogParams.dialogType === "forbid"
        ) {
          url = "/api/queue/admin/enable_warehouse";
        }
        this.$common
          .http({
            url: url,
            data: {
              id: this.rowDataObj.id
            }
          })
          .then(res => {
            console.log(res);
            // this.dialogMoveUpContent = `已成功删除“<span class="color67">${this.rowDataObj.name}</span>”的仓库信息。`;
            if (this.dialogParams.dialogType === "del") {
              this.$common.pcToastSuccess(
                `已成功删除“${this.rowDataObj.name}”的仓库信息。`
              );
            } else if (this.dialogParams.dialogType === "forbid") {
              this.$common.pcToastSuccess(
                `已成功禁用“${this.rowDataObj.name}”的仓库信息。`
              );
            } else if (this.dialogParams.dialogType === "start") {
              this.$common.pcToastSuccess(
                `已成功启用“${this.rowDataObj.name}”的仓库信息。`
              );
            }
            // this.dialogParams.dialogMoveUpShow = true;
            // this.dialogParams.title = "操作成功";
            this.getList();
            // setTimeout(() => {
            //   this.dialogParams.dialogMoveUpShow = false;
            // }, 1500);
          });
      } else {
        this.dialogParams.dialogMoveUpShow = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.storeListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 13px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
